
import { Component, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import { NewsService } from '@/services/index'
import Editor from '@/components/editor/index.vue'

@Component({
    name: 'ExtractArticle',
    components: {
        Editor
    }
})
export default class extends Vue {
    private articleRules = {
        title: [
            { required: true, message: '请输入新闻标题', trigger: 'blur' },
            { min: 2, max: 50, message: '新闻标题长度为2~50位', trigger: 'blur' }
        ],
        content: [
            { required: true, message: '请输入新闻正文', trigger: 'blur' }
            // { min: 20, max: 10000, message: '新闻正文长度为20~10000位', trigger: 'blur' }
        ]
    }
    private articleForm = {
        title: '',
        content: ''
    }
    private articleResult = {}
    private loading: boolean = false
    
    private mounted() {
    }

    private onContentChange(content: string) {
        this.articleForm.content = content
    }

    private onSubmit() {
        (this.$refs.articleForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const params = { title: this.articleForm.title, content: this.articleForm.content }
                const result = await NewsService.extractArticle(params)
                if (result.status === 200) {
                    this.articleResult = result.data
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            }
        })
    }
}
